import NoProductFoundIcon from "../Icons/NoProductFoundIcon.jsx";

export default function NoProducts({ onClearFilters }) {
  return (
    <div className="flex w-full px-4 md:px-8 py-8 md:py-16 flex-col justify-center items-center gap-6 md:gap-8">
      {/* Illustration - using custom NoProductFoundIcon */}
      <div className="relative md:w-[122px] md:h-[139px]">
        <NoProductFoundIcon />
      </div>

      {/* Content */}
      <div className="flex flex-col items-center gap-1 md:gap-1.5 w-full max-w-[290px] md:max-w-none">
        {/* Title */}
        <h2 className="font-akkurat text-mobile-h6-subhead-3 md:text-web-h6-subhead-3 text-text-primary">
          No matching results
        </h2>
        
        {/* Description */}
        <p className="font-akkurat text-mobile-s4-section-content-2 md:text-web-s3-section-content text-text-primary !font-normal">
          Try changing or removing some filters.
        </p>
      </div>

      {/* Clear All Filters Button */}
      <button
        onClick={onClearFilters}
        className="flex h-11 min-h-10 px-6 justify-center items-center gap-2 rounded bg-[#292425] hover:bg-[#3d3839] transition-colors"
      >
        <span className="font-akkurat text-web-cta-button-1 font-normal text-text-primary-inverse ">
          Clear All Filters
        </span>
      </button>
    </div>
  );
}
